import { RequestAction } from '@redux-requests/core';

import { actionPrefixer } from 'shared/utils/utils';
import { DestinationType } from 'shared/types/destination';

const prefix = actionPrefixer('APPLICATION_USER');

export const GET_API_CREDENTIALS = prefix('GET_API_CREDENTIALS');
export const REGENERATE_API_CREDENTIALS = prefix('REGENERATE_API_CREDENTIALS');

export const getApiCredentials = (destinationType: DestinationType): RequestAction => ({
  type: GET_API_CREDENTIALS,
  request: {
    url: `/services/oauth-key?application=${destinationType}`,
  },
  meta: {
    onSuccess: (response) => ({
      data: response,
    }),
  },
});

export const regenerateApiCredentials = (destinationType: DestinationType): RequestAction => ({
  type: REGENERATE_API_CREDENTIALS,
  request: {
    url: `/services/oauth-key?application=${destinationType}`,
    method: 'put',
  },
  meta: {
    onSuccess: (response) => ({
      data: response,
    }),
  },
});
